import React from "react";
import { ChipMenu } from "src/components/ui/menu";
import { Outlet } from "react-router-dom";

const MariaPage = () => {
  const items = React.useMemo(() => {
    const allowedItems = [];

    allowedItems.push({ to: "/admin/maria/", title: "Dashboard" });

    return allowedItems;
  }, []);

  return (
    <section>
      <ChipMenu level={3} style={{ marginBottom: 24 }} items={items} />
      <Outlet />
    </section>
  );
};

export default MariaPage;
